import React from "react";

import { Avatar, Box, Grid, Typography } from "@mui/material";

import styles from "./SecurityTopics.module.css";

const topics = [
  { number: 1, text: "Phishing & social engineering" },
  { number: 5, text: "Data leakage via third-party services" },
  { number: 2, text: "Passwords & two-factor authentication" },
  { number: 6, text: "Mobile threats & remote work" },
  { number: 3, text: "Handling confidential information" },
  {
    number: 7,
    text: "Each employee's responsibility for information security",
  },
  { number: 4, text: "Physical security" },
];

const SecurityTopics: React.FC<{ onTopicClick: (num: number) => void }> = ({
  onTopicClick,
}) => {
  return (
    <div className={styles.wrapper}>
      <Grid container>
        <Grid item xs={3}>
          <div className={styles.heading}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              className={styles.title}
            >
              7 Topics on
              <br />
              Information Security
            </Typography>
            <Typography variant="body2" className={styles.subtitle}>
              Presentation + Testing
            </Typography>
          </div>
        </Grid>
        <Grid item xs={9}>
          <Grid container spacing={1.75}>
            {topics.map(topic => (
              <Grid item xs={6} key={topic.text}>
                <Box
                  className={styles.item}
                  onClick={() => onTopicClick(topic.number)}
                  style={{ cursor: "pointer" }}
                >
                  <Avatar className={styles.number}>{topic.number}</Avatar>
                  <Typography variant="body2" className={styles.text}>
                    {topic.text}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default SecurityTopics;
